import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <RankingSection />
        <AboutSection />
        <UpdatesSection />
        <TopicsSection />
        <FaqSection />
        <IndexSection />
        <AppSection />
        <CardsSection />
        <FeaturesSection />
        <CommentsSection />
        <CarouselSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}